import { Helmet } from 'react-helmet';
import NewquanlytonkhoDetail
  from 'src/components/newquanlytonkho-detail/NewquanlytonkhoDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import NewquanlytonkhoListToolbar from '../components/newquanlytonkho-detail/NewquanlytonkhoToolbar';

const Newquanlytonkho = () => (
  <>
    <Helmet>
      <title>Quản lý tồn kho</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <NewquanlytonkhoListToolbar />
        <Box sx={{ pt: 3 }}>
          <NewquanlytonkhoDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Newquanlytonkho;
